import { createSlice } from '@reduxjs/toolkit';
import { fetchFactCheckApprovals } from './ApprovalsApi';

const fetchFactCheckApprovalsSlice = createSlice({
    name: 'fetchFactCheckApprovals',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handle fetchCommunityData cases
            .addCase(fetchFactCheckApprovals.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchFactCheckApprovals.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchFactCheckApprovals.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default fetchFactCheckApprovalsSlice.reducer;
